/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Health_TitleInputs */

const en_legal_health_title = /** @type {(inputs: Legal_Health_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consumer Health Data Privacy Policy`)
};

const pl_legal_health_title = /** @type {(inputs: Legal_Health_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polityka prywatności danych o zdrowiu konsumentów`)
};

/**
* | output |
* | --- |
* | "Consumer Health Data Privacy Policy" |
*
* @param {Legal_Health_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const legal_health_title = /** @type {((inputs?: Legal_Health_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Health_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_legal_health_title(inputs)
	return en_legal_health_title(inputs)
});